module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-bg"
  }, [_c('normalBar', {
    attrs: {
      "title": "物流详情"
    }
  }), _vm._v(" "), (_vm.expressList) ? _c('div', [_c('div', {
    staticClass: "cancel-info-sec"
  }, _vm._l((_vm.expressList), function(item) {
    return _c('div', {
      staticClass: "info-item active"
    }, [_c('span', {
      staticClass: "icon-circel"
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', [_c('p', {
      staticClass: "text-grey"
    }, [_vm._v(_vm._s(item.createdTime))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.optionHistory))])])])])
  })), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("暂无数据")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd400e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/expressList.vue
// module id = 564
// module chunks = 1